module.exports = __webpack_public_path__ + "img/join-meet.7278676f.svg";